module.exports = __webpack_public_path__ + "static/img/logo.7f51b0c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.jpg
// module id = 384
// module chunks = 31